import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import pendingActionsService from "./pendingActionsService";


const initialState = {
    isLoading: false,
    pending_claims_processes: null,
    pending_claims_count: 0,
    pending_savings_claim: null,
}

export const pendingActionsSlice = createSlice({
    name: "pendingActions",
    initialState,
    extraReducers: (builder) => {
        builder
          // Fetching Users
          .addCase(getPendingClaims.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getPendingClaims.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            if (action.payload) {
              state.pending_claims_processes = action.payload.pending_actions_data;
              state.pending_savings_claim = action.payload.saving_claim_data
              state.pending_claims_count = action.payload.total_pending_actions;
            }
          })
          .addCase(getPendingClaims.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
          })
    }
})

// Create user
export const getPendingClaims = createAsyncThunk(
    "/pendingActions/getPendingClaims",
    async (data, thunkAPI) => {
      try {
        return await pendingActionsService.getPendingClaims(data);
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

export default pendingActionsSlice.reducer;